import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col, Card, Badge, Button } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// external
import { motion } from 'framer-motion';
// redux
import { useSelector } from 'react-redux';

const Api = () => {
  const title = 'Api';
  const description = 'Integraciones Autopaquete';
  // - Global State from Store.js form Values
  const { currentUser } = useSelector((state) => state.auth);
  //  console.log('ffff:', currentUser);
  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className="page-title-container">
        <Row className="g-0 mb-5">
          {/* Title Start */}
          <Col className="col-auto mb-3 mb-sm-0 me-auto">
            <NavLink className="muted-link pb-1 d-inline-block hidden breadcrumb-back" to="/integraciones">
              <CsLineIcons icon="chevron-left" size="13" />
              <span className="align-middle text-small ms-1">Atrás</span>
            </NavLink>
            <h1 className="mb-0 pb-0 display-4" id="title">
              {title}
            </h1>
          </Col>
          {/* Title End */}
        </Row>
        <Row>
          {/* Introduction Banner Start */}
          <Col lg="8" className="mb-5">
            <Card className="sh-45 position-relative bg-theme">
              <img src="/img/illustration/api-banner.png" className="card-img h-100 position-absolute theme-filter" alt="card image" />
              {/* <img src="/img/illustration/database.webp" className="card-img h-100 position-absolute theme-filter" alt="card image" /> */}
              <div className="card-img-overlay d-flex flex-column justify-content-end bg-transparent">
                <div className="mb-4">
                  <div className="cta-1 mb-2 w-75 w-sm-50 text-primary">Integra nuestra API</div>
                  <div className="w-50 text-alternate">Conéctate a nuestro servicio mediante nuestra API REST y accede a todas sus funcionalidades.</div>
                </div>
                <div>
                  <Button
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://api.autopaquete.com.mx/public-docs/');
                    }}
                  >
                    <CsLineIcons icon="chevron-right" />
                    <span>Ver documentación</span>
                  </Button>
                </div>
              </div>
            </Card>
          </Col>
          {/* Introduction Banner End */}

          {/* Introduction List Start */}
          <Col lg="4" className="mb-5">
            {/* <h2 className="small-title">Access Token</h2> */}
            <Card>
              <Card.Body className="sh-45 d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <img src="/img/illustration/access-token.webp" className="theme-filter" alt="access" />
                  <div className="cta-3 mb-3">Token de producción</div>
                  <div className="cta-5 text-primary mb-2">Puedes solicitarlo fácilmente a nuestro equipo de soporte.</div>
                  <Button
                    className="mt-5"
                    variant="primary"
                    onClick={() =>
                      window.open(
                        `https://wa.me/+5213323381992/?text=${encodeURIComponent(
                          `Hola, me comunico de la cuenta ${currentUser.crmId}. ¿Podrías proporcionarme el token de producción, por favor?`
                        )}`
                      )
                    }
                  >
                    Solicitar token
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs="12" lg="6">
            <h2 className="small-title">Autenticación</h2>
            <Card>
              <Card.Body>
                <div className="pt-3 pb-4">
                  Todos los endpoints requieren un token de autenticación para identificar la cuenta de usuario que ejecuta las operaciones.
                  <br /> Este token debe enviarse en la cabecera Authorization de cada solicitud HTTP.
                </div>
                <div>
                  <div className="boxReq">
                    <div className="box__header backgroundBlack">
                      <span>Ejemplo de petición con autorización</span>
                    </div>
                    <div className="box__body backgroundGrey">
                      <div>
                        <code>
                          <ul className="u-list">
                            <li className="li-codeLine">
                              <span>
                                <span className="keyword">curl</span> <span className="string">"https://api.autopaquete.com.mx/v1/rates"</span>
                              </span>
                            </li>
                            <li className="li-codeLine">
                              <span>
                                <span className="keyword">-H</span> <span className="string">"Authorization: Bearer YOUR_API_KEY"</span>
                              </span>
                            </li>
                            <li className="li-codeLine">
                              <span>
                                <span className="keyword">-H</span> <span className="string">"Content-Type: application/json"</span>
                              </span>
                            </li>
                          </ul>
                        </code>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs="12" lg="6">
            <h2 className="small-title">Token de Pruebas</h2>
            <Card className="pb-5">
              <Card.Body>
                <div className="pt-3 pb-4">
                  Comienza la integración utilizando tu <strong>token de pruebas</strong>
                  <br />
                  Este token está vinculado a tu cuenta de usuario y te permite realizar pruebas sin afectar tu saldo ni generar cargos reales.
                </div>
                <div className="boxReq">
                  <div className="box__header backgroundBlack d-flex justify-content-end">
                    <span onClick={() => navigator.clipboard.writeText(currentUser.key_sandbox)}>
                      <CsLineIcons className="cursor-pointer" icon="clipboard" size="18" />
                    </span>
                  </div>
                  <div className="box__body backgroundGrey">
                    <ul className="u-list pt-3 pb-4">
                      <li className="codeLine">
                        <div className="keyword"> {currentUser?.key_sandbox}</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Introduction List End */}
        </Row>
      </div>
    </>
  );
};
export default Api;
